import { ToggleButton, Tooltip } from '@mui/material';
import useMark from '../hooks/useMark';

function MarkButton({ format, icon, tooltip }) {
    const { getMark, setMark } = useMark();
    const mark = getMark(format);

    return (
        <Tooltip title={tooltip}>
            <ToggleButton
                selected={mark}
                value={format}
                onMouseDown={e => {
                    e.preventDefault();
                    setMark(format, !mark);
                }}
            >
                {icon}
            </ToggleButton>
        </Tooltip>
    );
}

export default MarkButton;
